const protocol = location.protocol;
export const APP_ENV = 'production';

export const AUTH_LOW_SECURITY_COOKIE_NAME = `ttp_auth_ls_${APP_ENV}`;

export const LARAVEL_SESSION_COOKIE = 'ttp_session_production';

export const TTP_AMAZON_S3 = `${protocol}//s3.tamtam.pro/prod`;
export const TTP_API_URL = `${protocol}//api2.tamtam.pro`;
export const TTP_HOME_URL = `${protocol}//one.tamtam.pro/`;
export const TAMTAM_API_URL = `${protocol}//api.dev.tamtam.pro`;


export const TTP_BLOG_URL = `${protocol}//blog.tamtam.pro/`;
export const TTP_FLUX_URL = `${protocol}//ezine.tamtam.pro/`;
export const TTP_EMAILING_URL = `${protocol}//emailing.tamtam.pro/`;
export const TTP_EVENT_URL = `${protocol}//event.tamtam.pro/ttp/`;
export const TTP_TALK_URL = `${protocol}//talk.tamtam.pro`;
export const TTP_PAYMENT_URL = `${protocol}//stats.tamtam.pro/`;
export const TTP_MEDIA_URL = `${protocol}//media.tamtam.pro:3003/`;
export const TTP_FORUM_URL = `${protocol}//forum.tamtam.pro:3003/`;
export const TTP_WEBTOOL_URL = `${protocol}//webtool.tamtam.pro:3003/`;
export const TTP_UA_URL = `${protocol}//unitedassociates.be/`;

export const S3_FOLDER_URL = `https://s3.tamtam.pro/prod`;
export const S3_GEOJSON_FOLDER_URL = `https://s3.tamtam.pro/production`;
export const S3_STATS_FOLDER_URL = `https://s3.tamtam.pro/production/apps`;



export const RIB = `007 826 0002684000000426 89`;

export const CLIENT_CREDENTIAL = {
  grant_type: "client_credentials",
  client_id: "10012",
  client_secret: "EmailingSecretS#K$",
  scope: "ttp"
};

export const TAMTAM_CLIENT_ID = {'F.F.F.': 1, 'IEC-IAB': 3};

export const PSPID = 'forumforthefuture';
export const OGONE_URL = 'https://secure.ogone.com/ncol/prod/orderstandard.asp';

export const client_id= 'tamtampro_prod';
export const client_password= '7Av5DSYnApwrMpATUBYgHzF9nDu40xKa4g8TvcD5T6rDSgny2Q';
export const server_url= 'https://api.mangopay.com';
export const version= 'V2.01';

export const DROPBOX_CLIENT_ID = "4itq0i46p9zlybw";
export const DROPBOX_REDIRECT_URI = "https://api2.tamtam.pro/billing/coda-file/dropbox-token";



// WEBPACK FOOTER //
// ./app/config/ConfigProduction.js